import React from 'react';
import {Link} from 'react-router-dom';
import Header from '../templates/partials/header';
import Footer from '../templates/partials/footer';
import { connect } from 'react-redux';

const Main = (props) => {
    return <div className={props.page ? 'template-'+props.page.template : ''}>
        { props.page && props.page.showHeader && <Header /> }
      <section className="main">
        <div className="container">
          {props.children}
        </div>
      </section>
      <Footer template={props.page ? props.page.template : ''} />
    </div>;
}

export default connect(store => store.pageState)(Main);
